module.exports = __webpack_public_path__ + "static/frost_giant-1dbda965691bd426c03de5b915f98134.jpg";